import React, { useEffect, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";

import { useDispatch, useSelector } from "react-redux";

import { selectPagination } from "../../modules/Auth/_redux/authRedux";

import { useLocation } from "react-router-dom";
import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";
import { checkMenu } from "../../utility";
import { ReportIssueTab } from "./ReportIssueTab";
import { ReportIssueUploadTab } from "./ReportIssueUploadTab";
import { fetchMasterUpload } from "../miscellaneous/MiscellaneousSlice";

export const ReportIssueMenuPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [active, setActive] = useState("");
  const paginationSet = useSelector(selectPagination);
  const dataMenuTab = useSelector(selectMenuTab);
  const [list, setList] = useState(null);

  console.log(location.pathname, "location");

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      // await dispatch(
      //   fetchMenuTab({
      //     menu_url: "/master/product-related",
      //   })
      // );
      await dispatch(
        fetchMasterUpload({
          file_type: "REPORT_ISSUE,RESOLVE_ISSUE",
          pageNo: 1,
          pageSize: 10,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  // useEffect(() => {
  //   if (dataMenuTab.length > 0) {
  //     const data = dataMenuTab.map((item) => item.menu_name);
  //     setList(data);
  //     setActive(data[0]);

  //     const master = dataMenuTab.map((item, index) => {
  //       if (item.menu_name === "Product Master") {
  //         return dispatch(setPermissionProduct(item.permissions));
  //       }
  //       if (item.menu_name === "Model Master") {
  //         return dispatch(setPermissionModel(item.permissions));
  //       }
  //       if (item.menu_name === "Color Master") {
  //         return dispatch(setPermissionColor(item.permissions));
  //       }
  //     });
  //   }
  // }, [dataMenuTab]);

  return (
    <>
      <div>
        <Tabs id="uncontrolled-tab-example" onSelect={(e) => setActive(e)}>
          <Tab eventKey="Report Issue" title="Report Issue & Resolution">
            <ReportIssueTab />
          </Tab>
          <Tab eventKey="Upload" title="Upload">
            <ReportIssueUploadTab />
          </Tab>
        </Tabs>
      </div>
    </>
  );
};
